import React, { Component } from "react"
import {
  Dialog,
  Typography,
  DialogTitle,
  DialogContent,
  Divider,
  DialogActions,
  IconButton,
  Icon,
  List,
  Radio,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Button,
} from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import { CircularProgress } from "../../../node_modules/@material-ui/core/index"

class ChangeRepresentativeDialog extends Component {
  state = {
    checked: [],
    and: false,
    filterOptions: [],
    selectedManager: null,
  }

  componentDidMount() {
    const { creators, activeManager } = this.props

    this.setState({
      selectedManager: activeManager,
      filterOptions: creators.map(creator => {
        return {
          ...creator,
          type: "creator",
          name: `${creator.first_name} ${creator.last_name}`,
          func: shoot => shoot.creator_id === creator.id,
        }
      }),
    })
  }

  componentDidUpdate(p) {
    // if (!p.open && this.props.open) {
    //   const checked = this.props.creatorFilters.map(x =>
    //     this.props.creators.findIndex(
    //       y => y.first_name + " " + y.last_name === x
    //     )
    //   )
    //   this.setState({ checked })
    // }
  }

  onChange = data => {
    this.props.onChange(data, this.state.and)
  }

  closeDialog = () => {
    this.props.onClose(false)
  }

  render() {
    const { props, state, onChange } = this
    const { open, onClose, onClear, classes, activeManager, loading } = props
    const { checked, filterOptions, selectedManager } = state

    return (
      <Dialog onClose={this.closeDialog} open={open}>
        <DialogTitle className={classes.dialogTitle}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography style={{ fontWeight: "bold", color: "white" }}>
              Crew Mama Representatives
            </Typography>
            <div style={{ flexGrow: 1 }} />
            <IconButton onClick={onClose}>
              <Icon style={{ color: "white" }}>close</Icon>
            </IconButton>
          </div>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <List>
            {filterOptions.map((x, i) => {
              return (
                <ListItem
                  // style={{ marginRight: "128px" }}
                  className={
                    Number(selectedManager) === Number(x.id)
                      ? classes.activeRepresentative
                      : classes.representative
                  }
                  key={i}
                  button
                  disableRipple
                  onClick={() => this.setState({ selectedManager: x.id })}
                >
                  <ListItemIcon />
                  <ListItemText primary={x.name} secondary={x.description} />
                </ListItem>
              )
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <div style={{ flexGrow: 1 }} />
          <Button
            variant="text"
            color="primary"
            onClick={e => this.closeDialog()}
          >
            Close
          </Button>
          <Button
            onClick={e => {
              this.props.changeActiveRepresentative(selectedManager)
            }}
            variant="contained"
            color="primary"
          >
            {loading ? (
              <CircularProgress size={20} style={{ color: "white" }} />
            ) : (
              "Save"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(styles)(ChangeRepresentativeDialog)
